import ShopSalesDashboardContainer from './ShopSalesDashboardContainer';
export default ShopSalesDashboardContainer;
